var _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _use, _use2, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurahBannerOrnament(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 170",
    role: "img",
    "aria-label": "Surah ornament frame",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9f7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f2eedc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b8ab52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#cbbf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b8ab52"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "tinyDots",
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 0.75,
    fill: "#b7ab60",
    opacity: 0.22
  })), /*#__PURE__*/React.createElement("g", {
    id: "rosette"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 29,
    fill: "none",
    stroke: "#b6aa55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 21,
    fill: "none",
    stroke: "#bcae56",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-18 L4-6 L16-6 L6 2 L10 14 L0 7 L-10 14 L-6 2 L-16-6 L-4-6 Z",
    fill: "none",
    stroke: "#c6b95f",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#b6aa55"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 1196,
    height: 166,
    rx: 14,
    fill: "url(#bgGrad)",
    stroke: "#b7ab52",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1178,
    height: 148,
    rx: 12,
    fill: "none",
    stroke: "#bcaf59",
    strokeWidth: 1.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1160,
    height: 130,
    rx: 10,
    fill: "url(#tinyDots)",
    opacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 18,
    width: 380,
    height: 134,
    rx: 14,
    fill: "#f8f5e9",
    stroke: "url(#lineGrad)",
    strokeWidth: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410 38 H790",
    stroke: "#beaf57",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410 132 H790",
    stroke: "#beaf57",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 85 H390",
    stroke: "#b9ac54",
    strokeWidth: 1.8,
    opacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M810 85 H1166",
    stroke: "#b9ac54",
    strokeWidth: 1.8,
    opacity: 0.75
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#rosette",
    x: 145,
    y: 85
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#rosette",
    x: 1055,
    y: 85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46 C74 24, 110 24, 148 46",
    fill: "none",
    stroke: "#b7aa52",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124 C74 146, 110 146, 148 124",
    fill: "none",
    stroke: "#b7aa52",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1052 46 C1090 24, 1126 24, 1164 46",
    fill: "none",
    stroke: "#b7aa52",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1052 124 C1090 146, 1126 146, 1164 124",
    fill: "none",
    stroke: "#b7aa52",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272 48 C308 67, 330 103, 365 122",
    fill: "none",
    stroke: "#b8ab54",
    strokeWidth: 1.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M928 48 C892 67, 870 103, 835 122",
    fill: "none",
    stroke: "#b8ab54",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 85,
    r: 6,
    fill: "#b8ab54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 85,
    r: 6,
    fill: "#b8ab54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurahBannerOrnament);
export default __webpack_public_path__ + "static/media/surah-banner-ornament.81b9c917a3a4084f51893e4dad184acb.svg";
export { ForwardRef as ReactComponent };